import { render, staticRenderFns } from "./wfSelectionLifecycle.vue?vue&type=template&id=33062086&scoped=true&"
import script from "./wfSelectionLifecycle.vue?vue&type=script&lang=js&"
export * from "./wfSelectionLifecycle.vue?vue&type=script&lang=js&"
import style0 from "./wfSelectionLifecycle.vue?vue&type=style&index=0&id=33062086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33062086",
  null
  
)

export default component.exports